import { Phone, MessageCircle, Mail, MapPin, Linkedin, Facebook, Instagram, Twitter } from "lucide-react";
import { CONTACT, SERVICES, NAV_LINKS } from "@/lib/site";
import { scrollTo } from "./Navbar";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-navy text-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-20 pb-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center w-9 h-9 rounded-xl bg-white text-navy font-display font-black text-lg">A</span>
              <span className="font-display font-extrabold text-lg">Apex<span className="text-emerald">Credit</span></span>
            </div>
            <p className="mt-5 text-white/50 text-sm leading-relaxed max-w-xs">
              Empowering MSMEs with smart financial solutions. Funding business growth up to ₹5 Crore across Delhi NCR.
            </p>
            <div className="mt-6 flex gap-3">
              {[Linkedin, Facebook, Instagram, Twitter].map((Icon, i) => (
                <a key={i} href="#" aria-label="social" className="grid place-items-center w-9 h-9 rounded-lg bg-white/5 border border-white/10 hover:bg-brand transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display font-bold text-sm uppercase tracking-wider text-white/70">Services</h4>
            <ul className="mt-5 space-y-3">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.title}><button onClick={() => scrollTo("services")} className="text-white/55 hover:text-emerald transition-colors text-sm">{s.title}</button></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-sm uppercase tracking-wider text-white/70">Quick Links</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}><button onClick={() => scrollTo(l.id)} className="text-white/55 hover:text-emerald transition-colors text-sm">{l.label}</button></li>
              ))}
              <li><a href="#" className="text-white/55 hover:text-emerald transition-colors text-sm">Privacy Policy</a></li>
              <li><a href="#" className="text-white/55 hover:text-emerald transition-colors text-sm">Terms &amp; Conditions</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-sm uppercase tracking-wider text-white/70">Contact</h4>
            <ul className="mt-5 space-y-4 text-sm">
              <li><a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 text-white/55 hover:text-white transition-colors"><Phone className="w-4 h-4 text-emerald" /> {CONTACT.phone}</a></li>
              <li><a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/55 hover:text-white transition-colors"><MessageCircle className="w-4 h-4 text-emerald" /> WhatsApp</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-white/55 hover:text-white transition-colors"><Mail className="w-4 h-4 text-emerald" /> {CONTACT.email}</a></li>
              <li className="flex items-center gap-3 text-white/55"><MapPin className="w-4 h-4 text-emerald" /> {CONTACT.location}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">© {new Date().getFullYear()} Apex Credit Solutions. All rights reserved.</p>
          <p className="text-white/40 text-xs">Funding Business Growth.</p>
        </div>
      </div>

      <div className="font-display font-black text-white/[0.03] text-center leading-none select-none pointer-events-none text-[18vw] -mt-[3vw] pb-4">
        APEX CREDIT
      </div>
    </footer>
  );
};
